import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  buildVersion: {
    color: Theme.withOpacity(Theme.whisperWhite, 0.8),
    fontSize: Theme.px(30),
    textAlign: 'right',
  },
  wrapper: {
    elevation: 499,
    position: 'absolute',
    right: Theme.px(90),
    top: Theme.px(76),
    zIndex: 1000,
  },
});
